import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import {withMemo} from 'helpers/wrapper';
import {Span} from 'components/atoms/Text/Typography/Typography';
import Link from 'components/atoms/Links/Link/Link';
import StyledEmailField from 'components/molecules/Fields/EmailField/EmailField.styles';
import InputAdornment from 'components/atoms/Inputs/InputAdornment/InputAdornment';
import Icon from 'components/atoms/Icons/Icon/Icon';
import Email from '@mui/icons-material/Email';

const EmailField = withMemo(React.forwardRef((props, ref) => {
  const {
    showLinkIcon,
    ...innerProps
  } = useComponentProps(props, 'EmailField', {
    static: ['showLinkIcon']
  });

  const renderReadOnly = (value, props) => {
    if (value) {
      if (showLinkIcon) {
        return <React.Fragment>
          <InputAdornment size={innerProps?.size ?? 'small'}
                          position="start">
            <Link href={`mailto:${value}`}
                  onClick={(e) => e.stopPropagation()}>
              <Icon icon={Email} size="small"/>
            </Link>
          </InputAdornment>
          <Span showTooltip={props.showTooltip}>
            {value}
          </Span>
        </React.Fragment>;
      } else {
        return <Span showTooltip={props.showTooltip}>
          <Link href={`mailto:${value}`}
                onClick={(e) => e.stopPropagation()}>
            {value}
          </Link>
        </Span>
      }
    } else {
      return (props.placeholder && !props.hiddenPlaceholder) ?
        <Span className="placeholder" showTooltip={props.showTooltip}>{props.placeholder}</Span> :
        <Span>&nbsp;</Span>;
    }
  }

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledEmailField ref={ref} {...innerProps} renderReadOnly={renderReadOnly}/>
}));

EmailField.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  showLinkIcon: PropTypes.bool
};

export default EmailField;
